/* Native GET facets; progressively enhanced layout controls and next-page links. */
if (!customElements.get('misa-collection')) {
  customElements.define('misa-collection', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      const fallback = this.querySelector('.collection-filter-fallback');
      const form = fallback?.querySelector('form');
      const dialog = this.querySelector('dialog');
      if (form && dialog && typeof dialog.showModal === 'function') {
        dialog.append(form);
        fallback.hidden = true;
        this.querySelector('.collection-filter-toggle').hidden = false;
      }
      this.querySelector('.collection-view').hidden = false;
      this.addEventListener('click', event => {
        const view = event.target.closest('[data-columns]');
        if (view) {
          this.dataset[`${view.dataset.viewport}Columns`] = view.dataset.columns;
          this.querySelectorAll(`[data-viewport="${view.dataset.viewport}"]`).forEach(button => {
            button.setAttribute('aria-pressed', String(button === view));
          });
          this.updateImageSizes();
        }
        const more = event.target.closest('[data-load-more]');
        if (!more || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || more.dataset.fallback) return;
        event.preventDefault();
        if (!this.loading) this.loadMore(more);
      }, {signal:this.events.signal});
      // Correct sizes before a visitor chooses a wider layout; no viewport listener required.
      this.updateImageSizes();
    }
    disconnectedCallback() {
      this.events?.abort();
      this.request?.abort();
    }
    updateImageSizes() {
      const sizes = `(max-width: 767px) ${100 / Number(this.dataset.mobileColumns)}vw, (max-width: 1199px) 50vw, ${100 / Number(this.dataset.desktopColumns)}vw`;
      this.querySelectorAll('.product-card__media > img').forEach(img => img.sizes = sizes);
    }
    async loadMore(link) {
      this.loading = true;
      this.request = new AbortController();
      const status = this.querySelector('[data-collection-status]');
      const grid = this.querySelector('[data-product-grid]');
      const pagination = this.querySelector('[data-pagination]');
      const start = pagination.dataset.start;
      link.setAttribute('aria-disabled', 'true');
      grid.setAttribute('aria-busy', 'true');
      status.textContent = this.dataset.loadingText;
      const timeout = setTimeout(() => this.request.abort(), 15000);
      try {
        const url = new URL(link.href);
        url.searchParams.set('section_id', this.dataset.sectionId);
        const response = await fetch(url, {signal:this.request.signal, credentials:'same-origin'});
        if (!response.ok) throw new Error(`Collection HTTP ${response.status}`);
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextGrid = doc.querySelector('[data-product-grid]');
        const nextPagination = doc.querySelector('[data-pagination]');
        if (!nextGrid?.children.length || !nextPagination) throw new Error('Missing collection page');
        const firstLink = nextGrid.querySelector('a');
        grid.append(...nextGrid.children);
        nextPagination.dataset.start = start;
        if (start === '1') nextPagination.querySelector('[data-previous-page]')?.remove();
        const message = nextPagination.dataset.countText.replace('[from]', start).replace('[to]', nextPagination.dataset.end).replace('[total]', nextPagination.dataset.total);
        nextPagination.querySelector('[data-product-count]').textContent = message;
        pagination.replaceWith(nextPagination);
        this.updateImageSizes();
        status.textContent = message;
        firstLink?.focus({preventScroll:true});
      } catch (error) {
        if (this.isConnected) {
          status.textContent = this.dataset.errorText;
          link.dataset.fallback = 'true';
          link.removeAttribute('aria-disabled');
        }
      } finally {
        clearTimeout(timeout);
        this.loading = false;
        grid.removeAttribute('aria-busy');
      }
    }
  });
}
